import styled from 'styled-components';
import { INNER_DOC_CARD_TEMPLATE_COLUMNS } from '../../../../app/pages/Documents/style';

export const FixedContainer = styled.div`
  @media ${(props) => props.theme.device.mobileL} {
    padding: 0 16px;
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin: 16px 0 24px;

  @media ${(props) => props.theme.device.mobileL} {
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;

export const Sorting = styled.div`
  margin-bottom: 36px;
`;

export const Legend = styled.div`
  display: grid;
  gap: 38px;
  grid-template-columns: ${INNER_DOC_CARD_TEMPLATE_COLUMNS};
  margin-bottom: 16px;
`;

export const CardsWrapper = styled.div`
  @media ${(props) => props.theme.device.mobileL} {
    padding: 0 16px;
  }
`;

export const DocumentCard = styled(Legend)`
  height: 100px;
  padding: 29px 0 22px;
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
  border-radius: 4px;
  align-items: center;

  &.active {
    background-color: ${(props) => props.theme.colors.bgBox};
  }

  .title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  @media ${(props) => props.theme.device.tabletL} {
    height: fit-content;
    grid-template-columns: 120px 1fr;
    gap: 8px;
    width: 100%;
    margin-bottom: 0;
    box-shadow: none;
    border-bottom: 1px solid ${(props) => props.theme.colors.border};
    > *:nth-child(even) {
      text-align: right;
    }
  }
`;

export const FileImg = styled.img`
  width: 30px;
  height: 30px;
  display: block;
  margin-left: auto;
`;

export const PaginationWrapper = styled.div`
  padding-top: 30px;
  padding-bottom: 30px;

  > div {
    padding-bottom: 0;
  }
`;
